import React from 'react';
import { doc, collection, query, where, orderBy, onSnapshot } from 'firebase/firestore';
import { useParams } from 'react-router-dom';
import MsgNetLoading from '../components/MsgNetLoading';
import ResultadosScrapeable from '../components/ResultadosScrapeable';
import { FirebaseContext } from '../index';

class ScrapeableScreenClass extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            competicion: null,
            sectores: [],
            controles: [],
            resultados: []
        };
        this.unlisten = {};
    }

    componentDidMount() {
        const { db, params } = this.props;
        const competicionId = parseInt(params.competicionId, 10);

        // Competición
        const competicionRef = doc(db, 'competicion', competicionId.toString());
        this.unlisten.competicion = onSnapshot(competicionRef, (snapshot) => {
            let competicion = snapshot.exists() ? snapshot.data() : null;
            if (competicion) competicion.id = snapshot.id;
            this.setState({ competicion });
        });

        // Controles
        const controlesQuery = query(
            collection(db, 'control'),
            where('competicion_id', '==', competicionId),
            where('visible', '==', true),
            orderBy('distancia', 'asc')
        );
        this.unlisten.controles = onSnapshot(controlesQuery, (snapshot) => {
            let controles = snapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            }));
            this.setState({ controles });
        });

        // Sectores
        const sectoresQuery = query(
            collection(db, 'sector'),
            where('competicion_id', '==', competicionId),
            orderBy('inicio', 'asc')
        );
        this.unlisten.sectores = onSnapshot(sectoresQuery, (snapshot) => {
            let sectores = snapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            }));
            this.setState({ sectores });
        });
    }

    componentDidUpdate(prevProps, prevState) {
        const { db, params } = this.props;

        // Cargar resultados cuando llegan los controles
        if (prevState.controles !== this.state.controles && this.state.controles.length > 0) {
            const competicionId = parseInt(params.competicionId, 10);

            if (!this.unlisten.resultados) {
                const resultadosQuery = query(
                    collection(db, 'resultado'),
                    where('competicion_id', '==', competicionId)
                );
                this.unlisten.resultados = onSnapshot(resultadosQuery, (snapshot) => {
                    let resultados = snapshot.docs.map(doc => ({
                        id: doc.id,
                        ...doc.data()
                    }));
                    this.setState({ resultados });
                });
            }
        }
    }

    componentWillUnmount() {
        if (this.unlisten.competicion) this.unlisten.competicion();
        if (this.unlisten.controles) this.unlisten.controles();
        if (this.unlisten.resultados) this.unlisten.resultados();
        if (this.unlisten.sectores) this.unlisten.sectores();
    }

    render() {
        const { competicion, resultados, controles, sectores } = this.state;

        if (!competicion) {
            return (
                <div className="min-h-screen grid place-items-center bg-slate-950 text-slate-300">
                    <MsgNetLoading />
                </div>
            );
        }

        return (
            <div>
                {resultados.length > 0 && controles.length > 0 ? (
                    <ResultadosScrapeable
                        resultados={resultados}
                        competicion={competicion}
                        controles={controles}
                        sectores={sectores}
                    />
                ) : (
                    <div className="min-h-screen grid place-items-center bg-slate-950 text-slate-300">
                        <MsgNetLoading />
                    </div>
                )}
            </div>
        );
    }
}

// Wrapper funcional
function ScrapeableScreen() {
    const params = useParams();
    const { db } = React.useContext(FirebaseContext);

    return <ScrapeableScreenClass params={params} db={db} />;
}

export default ScrapeableScreen;